import { IComponentOptions, IController, IQService } from 'angular';
import { JobPositionService } from '../../../core/services/job-position/job-position.service';
import { JobRankService } from '../../../core/services/job-rank/job-rank.service';
import { GmcCvFilterService } from './gmc-cv-filter.service';
import { IVesselSectionsRes, ISectionVesselJob } from '../../../core/services/job-rank/job-rank.interfaces';
import { IModalCloseResult } from '../../../components/modals/gmc-modal/shared/index';
import { GmcFilterTypes } from './gmc-cv-filter-types';
import { IJobPositionCategory } from '../../../core/services/job-position/job-positions.interfaces';
import './gmc-cv-filter.component.scss';

export interface IGmcFilterCtrlData {
  filterType: GmcFilterTypes;
}

class GmcCvFilterController implements IController {
  static $inject = [
    'JobPositionService',
    'JobRankService',
    'GmcCvFilterService',
    '$q'
  ];
  sections: IVesselSectionsRes[];
  positions: IJobPositionCategory[];
  onClose: ( data: IModalCloseResult ) => void;
  selectedVessels: ISectionVesselJob[] = [];
  selectedPositions: IJobPositionCategory[] = [];
  data: IGmcFilterCtrlData;
  loading: boolean;

  constructor( private jobPositionService: JobPositionService,
               private jobRankService: JobRankService,
               private gmcCvFilterService: GmcCvFilterService,
               private $q: IQService ) {

  }

  $onInit() {
    this.loading = true;
    this.$q.all([
      this.jobPositionService.getPositions111(),
      this.jobRankService.fetchVesselJobs()
    ])
      .then(( [ positions, ranks ] ) => {
        console.log(positions);
        console.log(ranks);
        this.positions = positions;
        // this.sections = ranks;
        this.loading = false;
      })
      .catch(( err ) => {
        this.errorHandler(err);
        this.onClose({ result: null });
      });
  }

  closeModal() {
    switch ( this.data.filterType ) {
      case GmcFilterTypes.ONLY_POSITION:
        return this.onClose({ result: this.selectedPositions[ 0 ] }); // TODO
      case GmcFilterTypes.ONLY_SECTION:
        return this.onClose({ result: this.selectedVessels[ 0 ] });
      case GmcFilterTypes.SECTION_AND_POSITION:
        return this.onClose({ result: { vessels: this.selectedVessels, positions: this.selectedPositions } });
      default:
        return this.onClose({ result: null });
    }
  }

  private errorHandler( err: any ) {
    console.log(err);
  }

}

export const GmcCvFilterComponent: IComponentOptions = {
  controller: GmcCvFilterController,
  template: require('./gmc-cv-filter.component.html'),
  bindings: {
    data: '<',
    onClose: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-cv-filter/gmc-cv-filter.component.ts